/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable no-unused-vars */
import React from "react";
import { Container, Tab, Nav, Modal, Alert } from "react-bootstrap";
import "./HiringManagerCreateJob.scss";
import { JobDetails } from "./JobDetails";
import TeamMembers from "./TeamMembers/TeamMembers";
import Assessment from "./Assessment/Assessment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faXmark } from "@fortawesome/free-solid-svg-icons";
import useHiringManagerCreateJob from "./useHiringManagerCreateJob";
import Footer from "../../Common/Footer/Footer";
import MainLayout from "../../Common/MainLayout";

export default (props) => {
  const {
    jobDetailsRef,
    jobTitle,
    closeJobModal,
    jobDetails,

    closeJobModalOpenHandler,
  } = useHiringManagerCreateJob(props);

  return (
    <MainLayout pageName="Create Job">
      <div className="create-job-wrapper footer-gap">
        <div className="top bg-grey pb-4">
          <Container>
            <div className="d-flex justify-content-between align-items-center pt-3">
              <h2 className="text-dark">
                {jobDetails?.title
                  ? jobDetails?.title
                  : "Job Title"}
              </h2>

              <div className="btns-wrapper text-right">
                <button
                  className="btn btn-light mr-3 mb-3"
                  onClick={() => jobDetailsRef.current.submitDraft()}
                >
                  Save draft
                </button>

                {jobTitle?.id && (
                  <button
                    className="btn btn-primary mb-3"
                    onClick={() => jobDetailsRef.current.publishForm()}
                  >
                    Save and Publish
                  </button>
                )}
                {jobTitle?.id && (
                  <button
                    className="btn btn-danger mb-3 ml-3"
                    onClick={() => closeJobModalOpenHandler(true)}
                  >
                    Close Job
                  </button>
                )}
              </div>
            </div>
          </Container>
        </div>

        <Tab.Container className="mb-3 pb-4" defaultActiveKey="Job Detail">
          <div className="bg-grey">
            <div className="container px-0">
              <Nav className="nav-tabs pb-4">
                <Nav.Item>
                  <Nav.Link eventKey="Job Detail">
                    <span className="font-weight-semi text-dark">
                      Job Detail
                    </span>
                    <span className="text-grey-4 fs-smallest d-none d-md-block">
                      Tell applicants why it's great to <br />
                      work at company name.
                    </span>
                  </Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link
                    eventKey="Application Form"
                    disabled={jobTitle?.id === undefined}
                  >
                    <span className="font-weight-semi text-dark">
                      Application Form{" "}
                    </span>
                    <span className="d-none d-md-block text-grey-4 fs-smallest">
                      Design the application form for
                      <br />
                      this role.
                    </span>
                  </Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link eventKey="Team Members">
                    <span className="font-weight-semi text-dark">
                      Team Members{" "}
                    </span>
                    <span className="d-none d-md-block text-grey-4 fs-smallest">
                      Invite or add co-workers to
                      <br />
                      collaborate on this job.
                    </span>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="Assessment">
                    <span className="font-weight-semi text-dark">
                      Assessment{" "}
                    </span>
                    <span className="d-none d-md-block text-grey-4 fs-smallest">
                      Create a kit or assessment test for
                      <br />a structured interview process.
                    </span>
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </div>
          </div>
          <Tab.Content>
            <Tab.Pane eventKey="Job Detail" title="Job Detail">
              <JobDetails ref={jobDetailsRef} />
            </Tab.Pane>
            {/* <Tab.Pane
                  eventKey="Application Form"
                  title="Application Form"
                  disabled={jobTitle === undefined}
                >
                  <ApplicationForm />
                </Tab.Pane> */}
            <Tab.Pane
              eventKey="Team Members"
              title="Team Members"
              disabled={jobTitle === undefined}
            >
              <TeamMembers />
            </Tab.Pane>
            <Tab.Pane
              eventKey="Assessment"
              title="Assessment"
              disabled={jobTitle === undefined}
            >
              <Assessment />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>

        <Modal
          size="lg"
          show={closeJobModal}
          className="common-modal "
          onHide={() => closeJobModalOpenHandler(false)}
          centered
        >
          <Modal.Header className="d-flex justify-content-between align-items-center bg-grey-2 px-4">
            <p className="mb-0 mr-4 fs-16 font-weight-medium">
              Invite Candidate to Job.
            </p>
            <FontAwesomeIcon
              icon={faXmark}
              className="text-grey-4 fa-2x"
              onClick={() => closeJobModalOpenHandler(false)}
            />
          </Modal.Header>
          <Modal.Body className="bg-white px-4 pt-4">
            <h3>Do you really want to close this Job?</h3>
          </Modal.Body>
          <Modal.Footer className="bg-white px-4 pt-4">
            <button
              className="btn btn-danger"
              onClick={() => jobDetailsRef.current.submitClose()}
            >
              Close
            </button>
            <button
              className="btn btn-dark"
              onClick={() => closeJobModalOpenHandler(false)}
            >
              Cancel{" "}
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </MainLayout>
  );
};
